module.exports = __webpack_public_path__ + "static/media/multi-love.db2708ec.jpg";